/**
 * API エラーから HTTP ステータスコードを取り出す。
 * configs/axios のレスポンスインターセプタは error.status に response.status を
 * 写しているが、インターセプタを通らない生の AxiosError でも同じ結果になるよう
 * response.status を優先して両方を見る。ネットワークエラーなど応答が無い場合や
 * エラーがオブジェクトでない場合は undefined を返す。
 */
export const getHttpStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const source = error as {
    status?: unknown;
    response?: { status?: unknown } | null;
  };
  const status = source.response?.status ?? source.status;
  return typeof status === 'number' ? status : undefined;
};
